// Soft two-note chime for notifications. Synthesized with Web Audio so
// there's no asset to load. Rings for hidden tabs too — browsers allow
// audio from background tabs, though only after the tab has been
// interacted with at least once (autoplay policy).

let ctx: AudioContext | null = null;
let lastChimeAt = 0;

const THROTTLE_MS = 2000; // a burst of inserts rings once, not per row

export function playChime(): void {
  try {
    if (typeof document === 'undefined') return;
    const now = Date.now();
    if (now - lastChimeAt < THROTTLE_MS) return;
    lastChimeAt = now;

    ctx = ctx ?? new AudioContext();
    // Browsers gate audio behind a first user gesture; resume is a no-op
    // when already running and quietly fails before any interaction.
    if (ctx.state === 'suspended') void ctx.resume();

    const t0 = ctx.currentTime;
    const notes = [
      { freq: 880, at: 0 }, // A5
      { freq: 1318.5, at: 0.12 }, // E6
    ];
    for (const { freq, at } of notes) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, t0 + at);
      gain.gain.linearRampToValueAtTime(0.35, t0 + at + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + at + 0.6);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t0 + at);
      osc.stop(t0 + at + 0.65);
    }
  } catch {
    // audio unavailable — stay silent
  }
}
